function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPharmacySupport = function SvgPharmacySupport(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M8.5 9.5h8m-8 3.5h5m-8 7V6h14v10.5h-9.333z"
  }));
};
export default SvgPharmacySupport;